// Existing v2 extraction contracts normalize numeric postnatal ages to years.
// Preserve explicit source units and named prenatal/observation periods.
export function displayTimepoint(value) {
  const label=String(value ?? '').trim();
  return /^\d+(?:\.\d+)?$/.test(label) ? `${label} years` : label;
}
